// src/components/ProtectedRoute.tsx
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { LoadingState } from './ui';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { author, token, loading } = useAuth();

  if (loading) {
    // Optionally, render a spinner or loading message while authentication check is in progress
    return <LoadingState fullPage label="Vérification de l'authentification..." />;
  }

  if (!author || !token) {
    // User is not authenticated, redirect them to the home page or an access denied page
    return <Navigate to="/unauthorized-access" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
